import { Serializer } from "./serializer";
import { optional } from "./serializers/optional";

const nullable = <T>(serializer: Serializer<T>): Serializer<T | null> => ({
  ...serializer,
  serialize: (value) => {
    if (value === null) return value;
    return serializer.serialize(value);
  },
  deserialize: (raw) => {
    if (raw === null) return raw;
    return serializer.deserialize(raw);
  },
});

export interface SerializerExtensions<T> {
  nullable: () => Serializer<T | null>;
  optional: () => Serializer<T | undefined>;
}

export const serializerExtensions = <T>(): SerializerExtensions<T> => ({
  nullable(this: any) {
    return nullable(this);
  },
  optional(this: any) {
    return optional(this);
  },
});
